import { stubTrue } from 'lodash';
import LogRocket from 'logrocket';

export const subscribeToWebSocket = (
    onMessage,
    callback,
    { filter = stubTrue, oneTimeHandler = false, id, sourceFilter } = {}
) => {
    const unsubscribe = onMessage(message => {
        LogRocket.log('Socket received: ', JSON.stringify(message?.data));

        let data;
        try {
            data = JSON.parse(message.data);
        } catch (error) {
            console.error('Failed to parse WebSocket message', error);
            return;
        }

        const dataMessage = data?.message;

        if (sourceFilter) {
            if (data?.source === sourceFilter) {
                callback(dataMessage);
                if (oneTimeHandler) {
                    unsubscribe();
                }
            }
            return;
        }

        if (filter(dataMessage)) {
            callback(dataMessage);

            if (oneTimeHandler) {
                unsubscribe();
            }
        }
    }, id);

    return unsubscribe;
};
